<template>
  <v-btn-toggle v-model="selectedIndices" multiple small>
    <v-tooltip top v-for="patientRisk in patientRisks" :key="patientRisk.id">
      <template v-slot:activator="{ on: listeners }">
        <v-btn
          v-on="listeners"
          :color="colorForPatientRisk(patientRisk)"
          :dark="isDarkPatientRisk(patientRisk)"
          x-small
          min-width="5"
        />
      </template>

      {{ patientRisk.name }}
    </v-tooltip>
  </v-btn-toggle>
</template>

<script>
import {
  colorForPatientRisk,
  isDarkPatientRisk,
} from "@/components/queues/attendance/patient_risk/colors.js";

export default {
  name: "PatientRiskSelect",
  props: {
    value: {
      type: Array,
      required: true,
    },
    patientRisks: {
      type: Array,
      required: true,
    },
  },
  methods: {
    colorForPatientRisk(patientRisk) {
      return colorForPatientRisk(this.$Color(), patientRisk);
    },
    isDarkPatientRisk(patientRisk) {
      return isDarkPatientRisk(this.$Color(), patientRisk);
    },
  },
  computed: {
    selectedIndices: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle > .v-btn.v-btn--active {
  color: transparent;
  opacity: 1;
}

.v-btn-toggle > .v-btn.v-btn {
  opacity: 1;
}
</style>
